import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ea2c7486"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ea2c7486&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderCampus: require('/home/etienne/AM-frontend/components/HeaderCampus.vue').default,CampusAdvantagesUnderLogo: require('/home/etienne/AM-frontend/components/CampusAdvantagesUnderLogo.vue').default,Diplomes3Collone: require('/home/etienne/AM-frontend/components/Diplomes3Collone.vue').default,Diplomes: require('/home/etienne/AM-frontend/components/Diplomes.vue').default})
